var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.NewAutocomplete,{ref:"divisionAutocomplete",attrs:{"label":"Division","value":_vm.value,"use-search-items":_setup.searchDivisions,"value-resolver":_setup.valueResolver,"is-disabled":_vm.isDisabled,"required":""},on:{"selected":_setup.updateNewValue}})
}
var staticRenderFns = []

export { render, staticRenderFns }